














import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import VModal from "./VModal.vue";

@Component({
  components: {
    VModal,
  },
})
export default class DetailsModal extends Vue {
  @Prop({ required: true }) readonly title!: string;
  @Prop({ default: "" }) readonly subject!: string;
  @Prop({ default: "Chiudi" }) readonly closeLabel!: string;

  @Ref("modal") readonly modal!: VModal;

  show() {
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }
}
